<template>
  <div>
    <div class="text-center w-full">
      <p class="text-24 md:text-47 font-bold">Company info</p>
      <p class="text-20 text-grey-20">Let’s set up a workspace for you and your team.</p>
    </div>

    <div class="flex mt-30 mx-auto">
      <img v-if="image" class="rounded-6 h-115 max-w-full mx-auto object-contain" :src="image" alt="image">

      <label v-else class="block mx-auto cursor-pointer brightness anim-all">
        <img class="h-105 max-w-full" src="@/assets/images/signup/upload.svg" alt="upload">
        <p class="text-center mt-10 font-medium">Upload logo</p>
        <input ref="inputRef" type="file" class="hidden" @change="uploadLogo">
      </label>
    </div>

    <InputModule
      ref="companyNameRef"
      v-model="companyName"
      name="companyName"
      label="Company name"
      placeholder="Acme inc."
      class="w-full mt-30 font-bold"
      input-classes="px-22 py-13 rounded-10 border border-grey-10 focus:border-brand anim-all text-17"
      label-class="mb-5 font-bold"
      shadow="focus:shadow-signup"
      :has-background="false"
      :error-message="errorMessages.companyName"
      @clearErrorMessage="clearErrorMessage"
    />

    <ButtonModule
      text="Continue"
      suffix="relative icon-arrow-right ml-10 mt-2 text-10 left-0 group-hover:left-7 anim-all"
      class="w-full justify-center bg-brand hover:bg-brand-hover text-white rounded-10 mt-30 py-16 group font-medium text-17"
      @click="continueRegister"
    />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, nextTick } from 'vue'

import InputModule from '@/components/shared/form-controls/InputModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import { requiredFieldsValidation } from '@/helpers'

export default defineComponent({
  name: 'SignUpTeams',

  components: { InputModule, ButtonModule },

  props: {
    user: Object,
    modelValue: Object
  },

  emits: ['next', 'update:modelValue'],

  setup (props, { emit }) {
    const companyNameRef = ref('')
    const companyName = ref('')
    const file = ref(null)
    const image = ref(null)

    const currentlValue = ref(0)

    const errorMessages = reactive({
      companyName: null
    })

    onMounted(() => {
      nextTick(() => {
        companyNameRef.value.focus()
      })
    })

    function uploadLogo (event) {
      const hasFiles = event.target.files.length

      if (!hasFiles) return

      const files = Array
        .from(event.target.files)
        .filter(file => (/image/i).test(file.type))

      if (files.length === 0) return

      const formData = new FormData()
      formData.append('data', files[0])

      createImage(files[0])

      file.value = formData
    }

    function createImage (file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        image.value = e.target.result
      }
      reader.readAsDataURL(file)
    }

    const continueRegister = () => {
      requiredFieldsValidation(errorMessages, { companyName: companyName.value })

      if (Object.values(errorMessages).every(i => !i)) {
        emit('next')
        emit('update:modelValue', {
          logo: file.value,
          name: companyName.value
        })
      }
    }

    function clearErrorMessage (name) {
      errorMessages[name] = null
    }

    return {
      // refs
      companyNameRef,
      companyName,
      image,
      currentlValue,
      // reactive
      errorMessages,
      // function
      uploadLogo,
      continueRegister,
      clearErrorMessage
    }
  }
})
</script>

<style scoped>
.brightness:hover {
  filter: brightness(0.9);
}
</style>
